import React from 'react';
import { Jumbotron } from './migration';

const Video = ({ heading }) => {
    return (
        <Jumbotron id="video" className="m-0">
            <div className="container">
                <h2 className="display-4 mb-5 text-center">{heading}</h2>
                <div className="row">
                    <div className="col-7 d-flex align-items-center justify-content-center">
                        <p>
                            Attached here is a link to a video I recently created for my summer class, ENG388, where I teach you how to train an AI model to generate images with your face in them.
                        </p>
                    </div>
                    <div className="col-5 d-none d-lg-block align-self-center">
                        <iframe width="560" height="315" src="https://www.youtube.com/embed/1uOw22P36GA" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
                    </div>
                </div>
                <div className="row">
                    <div className="col-7 d-flex align-items-center justify-content-center">
                        <p>
                            I've also attatched here a usability report I conducted regarding the written instructions manual I wrote. You can find the written report above under my GitHub projects section--it's written in Markdown, so what better place to upload it than GitHub?
                        </p>
                    </div>
                    <div className="col-5 d-none d-lg-block align-self-center">
                    <iframe title="usabilityReport" width="560" height="315" src="https://docs.google.com/document/d/e/2PACX-1vS847FjU2VS3Ir7dcPRmTvh-RRRkMdP0Z0VYVIXD6XaPpcFfQ6a_rG06L1ValIPUykoMv6JyA8ZQSy2/pub?embedded=true"></iframe>
                    </div>
                </div>
            </div>
        </Jumbotron>
    );
};

export default Video;
